import { Action } from 'infra/types'
import { listActions } from 'state/new-summary/list/list.actions'
import { ICreateNewListState } from './create-new-list.types'
import { createNewListDrawerActions } from './create-new-list.actions'

const CREATE_NEW_LIST_STATE: ICreateNewListState = {
  newListName: '',
  drawers: {
    showCreateNewListDrawer: false,
    showListCustomerForOrderSetting: false,
    showCustomersListDrawer: false,
    showDailyAssignmentDrawer: false,
    showAssignedInventories: false
  },
  activeSaleAssignment: undefined,
  saleAllocation: [],
  loaders: {
    initAssignment: false
  }
}

export const CreateNewListReducer = (
  state: ICreateNewListState = CREATE_NEW_LIST_STATE,
  action: Action<any>
): ICreateNewListState => {
  switch (action.type) {
    case createNewListDrawerActions.SET_CREATE_NEW_LIST_DRAWER: {
      return {
        ...state,
        newListName: action.payload.newListName || state.newListName,
        updateListProps: undefined,
        drawers: {
          ...state.drawers,
          showCreateNewListDrawer: action.payload.drawerStatus,
          showCustomersListDrawer: action.payload.showCustomersListDrawer
        }
      }
    }

    case createNewListDrawerActions.RESET_CREATE_NEW_LIST_DRAWER: {
      return {
        ...state,
        newListName: '',
        updateListProps: undefined,
        drawers: {
          ...state.drawers,
          showCreateNewListDrawer: false,
          showCustomersListDrawer: false
        }
      }
    }
    case createNewListDrawerActions.SET_UPDATE_LIST_DRAWER: {
      return {
        ...state,
        updateListProps: {
          existingUsageType: action.payload.existingUsageType,
          existingListName: action.payload.existingListName,
          existingListType: action.payload.existingListType,
          isClearAndAdd: action?.payload?.isClearAndAdd || false
        },
        drawers: {
          ...state.drawers,
          showCreateNewListDrawer: action.payload.drawerStatus
        }
      }
    }

    case createNewListDrawerActions.SHOW_LIST_CUSTOMER_FOR_ORDER_SETTING: {
      return {
        ...state,
        labelFilterAccountIds: action.payload.labelFilterAccountIds,
        drawers: {
          ...state.drawers,
          showListCustomerForOrderSetting: action.payload.isShowCustomerListForOrderSetting
        }
      }
    }

    case createNewListDrawerActions.SET_ALL_SETTINGS_DRAWERS_ACTION: {
      return {
        ...state,
        drawers: {
          ...state.drawers,
          [action.payload.id]: action.payload.value
        }
      }
    }

    case createNewListDrawerActions.SAVE_ACTIVE_SALE_ASSIGNMENT: {
      return {
        ...state,
        activeSaleAssignment: action.payload.activeAssignment
      }
    }

    case createNewListDrawerActions.SAVE_SALE_ALLOCATION: {
      return {
        ...state,
        saleAllocation: action.payload.saleAllocations
      }
    }

    case listActions.FETCH_ACTIVE_SALE_ALLOCATION: {
      return {
        ...state,
        activeSaleAssignment: undefined,
        saleAllocation: []
      }
    }

    case createNewListDrawerActions.SET_ALLOCATION_LIST_LOADERS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [action.payload.loaderName]: action.payload.status
        }
      }
    }

    default: {
      return state
    }
  }
}
